var _style, _style2, _g, _span, _span2, _span3, _span4, _span5, _span6, _span7, _span8, _rect, _span9, _rect2, _span10, _rect3, _span11, _rect4, _span12, _rect5, _span13, _rect6, _span14, _rect7, _span15, _rect8, _span16, _rect9, _span17, _defs, _defs2, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase5VectorSearchViz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-roledescription": "flowchart-v2",
    role: "graphics-document document",
    viewBox: "0 0 309.421875 1010",
    style: {
      maxWidth: "309.422px",
      background: "rgb(23, 23, 25)"
    },
    className: "flowchart",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    id: "export-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css\"); p {margin: 0;}")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "#export-svg{font-family:arial,sans-serif;font-size:14px;fill:#ccc;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#export-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#export-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#export-svg .error-icon{fill:hsl(20, 1.5873015873%, 12.3529411765%);}#export-svg .error-text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);stroke:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .edge-thickness-normal{stroke-width:1px;}#export-svg .edge-thickness-thick{stroke-width:3.5px;}#export-svg .edge-pattern-solid{stroke-dasharray:0;}#export-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#export-svg .edge-pattern-dashed{stroke-dasharray:3;}#export-svg .edge-pattern-dotted{stroke-dasharray:2;}#export-svg .marker{fill:#cccccc;stroke:#cccccc;}#export-svg .marker.cross{stroke:#cccccc;}#export-svg svg{font-family:arial,sans-serif;font-size:14px;}#export-svg p{margin:0;}#export-svg .label{font-family:arial,sans-serif;color:#e0dfdf;}#export-svg .cluster-label text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster-label span{color:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster-label span p{background-color:transparent;}#export-svg .label text,#export-svg span{fill:#e0dfdf;color:#e0dfdf;}#export-svg .node rect,#export-svg .node circle,#export-svg .node ellipse,#export-svg .node polygon,#export-svg .node path{fill:#2a2020;stroke:#ccc;stroke-width:1px;}#export-svg .rough-node .label text,#export-svg .node .label text,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-anchor:middle;}#export-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#export-svg .rough-node .label,#export-svg .node .label,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-align:center;}#export-svg .node.clickable{cursor:pointer;}#export-svg .root .anchor path{fill:#cccccc!important;stroke-width:0;stroke:#cccccc;}#export-svg .arrowheadPath{fill:#cccccc;}#export-svg .edgePath .path{stroke:#cccccc;stroke-width:1px;}#export-svg .flowchart-link{stroke:#cccccc;fill:none;}#export-svg .edgeLabel{background-color:hsl(180, 1.5873015873%, 28.3529411765%);text-align:center;}#export-svg .edgeLabel p{background-color:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .edgeLabel rect{opacity:0.5;background-color:hsl(180, 1.5873015873%, 28.3529411765%);fill:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .labelBkg{background-color:rgba(71.1523809525, 73.4476190477, 73.4476190477, 0.5);}#export-svg .cluster rect{fill:hsl(20, 1.5873015873%, 12.3529411765%);stroke:hsl(20, 0%, 2.3529411765%);stroke-width:1px;}#export-svg .cluster text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster span{color:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(20, 1.5873015873%, 12.3529411765%);border:1px solid rgba(255, 255, 255, 0.25);border-radius:2px;pointer-events:none;z-index:100;}#export-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#ccc;}#export-svg rect.text{fill:none;stroke-width:0;}#export-svg .icon-shape,#export-svg .image-shape{background-color:hsl(180, 1.5873015873%, 28.3529411765%);text-align:center;}#export-svg .icon-shape p,#export-svg .image-shape p{background-color:hsl(180, 1.5873015873%, 28.3529411765%);padding:2px;}#export-svg .icon-shape rect,#export-svg .image-shape rect{opacity:0.5;background-color:hsl(180, 1.5873015873%, 28.3529411765%);fill:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .node .neo-node{stroke:#ccc;}#export-svg [data-look=\"neo\"].node rect,#export-svg [data-look=\"neo\"].cluster rect,#export-svg [data-look=\"neo\"].node polygon{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node path{stroke:url(#export-svg-gradient);}#export-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node .neo-line path{stroke:#ccc;filter:none;}#export-svg [data-look=\"neo\"].node circle{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#export-svg [data-look=\"neo\"].statediagram-cluster rect{fill:#2a2020;stroke:url(#export-svg-gradient);stroke-width:1px;}#export-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg :root{--mermaid-font-family:\"trebuchet ms\",verdana,arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 7.75,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 4,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 11.5,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 1,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart-margin"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 10.75,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 0,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 12.25,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: -2,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjk1fSx7IngiOjE1NC43MTA5Mzc1LCJ5IjoxMjB9LHsieCI6MTU0LjcxMDkzNzUsInkiOjE0NX1d",
    "data-id": "L_P6_1_P6_2_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_1_P6_2_0",
    d: "M154.7109375,95L154.7109375,120L154.7109375,141"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjE5MH0seyJ4IjoxNTQuNzEwOTM3NSwieSI6MjE1fSx7IngiOjE1NC43MTA5Mzc1LCJ5IjoyNDB9XQ==",
    "data-id": "L_P6_2_P6_3_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_2_P6_3_0",
    d: "M154.7109375,190L154.7109375,215L154.7109375,236"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjMwNn0seyJ4IjoxNTQuNzEwOTM3NSwieSI6MzMxfSx7IngiOjE1NC43MTA5Mzc1LCJ5IjozNTZ9XQ==",
    "data-id": "L_P6_3_P6_4_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_3_P6_4_0",
    d: "M154.7109375,306L154.7109375,331L154.7109375,352"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjQyMn0seyJ4IjoxNTQuNzEwOTM3NSwieSI6NDQ3fSx7IngiOjE1NC43MTA5Mzc1LCJ5Ijo0NzJ9XQ==",
    "data-id": "L_P6_4_P6_5_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_4_P6_5_0",
    d: "M154.7109375,422L154.7109375,447L154.7109375,468"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjUzOH0seyJ4IjoxNTQuNzEwOTM3NSwieSI6NTYzfSx7IngiOjE1NC43MTA5Mzc1LCJ5Ijo1ODh9XQ==",
    "data-id": "L_P6_5_P6_6_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_5_P6_6_0",
    d: "M154.7109375,538L154.7109375,563L154.7109375,584"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjY3NX0seyJ4IjoxNTQuNzEwOTM3NSwieSI6NzAwfSx7IngiOjE1NC43MTA5Mzc1LCJ5Ijo3MjV9XQ==",
    "data-id": "L_P6_6_P6_7_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_6_P6_7_0",
    d: "M154.7109375,675L154.7109375,700L154.7109375,721"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjc5MX0seyJ4IjoxNTQuNzEwOTM3NSwieSI6ODE2fSx7IngiOjE1NC43MTA5Mzc1LCJ5Ijo4NDF9XQ==",
    "data-id": "L_P6_7_P6_8_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_7_P6_8_0",
    d: "M154.7109375,791L154.7109375,816L154.7109375,837"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTU0LjcxMDkzNzUsInkiOjkwN30seyJ4IjoxNTQuNzEwOTM3NSwieSI6OTMyfSx7IngiOjE1NC43MTA5Mzc1LCJ5Ijo5NTd9XQ==",
    "data-id": "L_P6_8_P6_End_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P6_8_P6_End_0",
    d: "M154.7109375,907L154.7109375,932L154.7109375,953"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_1_P6_2_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span || (_span = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_2_P6_3_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span2 || (_span2 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_3_P6_4_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span3 || (_span3 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_4_P6_5_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span4 || (_span4 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_5_P6_6_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span5 || (_span5 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_6_P6_7_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span6 || (_span6 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_7_P6_8_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span7 || (_span7 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P6_8_P6_End_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span8 || (_span8 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 51.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_1",
    id: "flowchart-P6_1-0",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 87,
    width: 232,
    y: -43.5,
    x: -116,
    ry: 3,
    "data-id": "P6_1",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -31.5)",
    style: {},
    className: "label"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 63,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span9 || (_span9 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.1 Define Verification Functions\\n(view_schema_info, collection_info)"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 167.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_2",
    id: "flowchart-P6_2-1",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 222.640625,
    y: -22.5,
    x: -111.3203125,
    ry: 3,
    "data-id": "P6_2",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-95.3203125, -10.5)",
    style: {},
    className: "label"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 190.640625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span10 || (_span10 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.2 List ChromaDB Collections"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 273)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_3",
    id: "flowchart-P6_3-2",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    ry: 3,
    "data-id": "P6_3",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span11 || (_span11 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.3 Get ChromaDB Collection Summaries"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 389)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_4",
    id: "flowchart-P6_4-3",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    ry: 3,
    "data-id": "P6_4",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span12 || (_span12 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.4 Inspect 'recipes' Collection Schema"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 505)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_5",
    id: "flowchart-P6_5-4",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    ry: 3,
    "data-id": "P6_5",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span13 || (_span13 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.5 Inspect 'interactions' Collection Schema"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 631.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_6",
    id: "flowchart-P6_6-5",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 87,
    width: 293.421875,
    y: -43.5,
    x: -146.7109375,
    ry: 3,
    "data-id": "P6_6",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130.7109375, -31.5)",
    style: {},
    className: "label"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 63,
    width: 261.421875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span14 || (_span14 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.6 Define Similarity Search Funcs\\n(gemini_recipe_similarity_search, etc.)"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 758)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_7",
    id: "flowchart-P6_7-6",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    ry: 3,
    "data-id": "P6_7",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span15 || (_span15 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.7 Test Recipe Similarity Search"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 874)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_8",
    id: "flowchart-P6_8-7",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    ry: 3,
    "data-id": "P6_8",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span16 || (_span16 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "6.8 Test Interaction Similarity Search"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.7109375, 979.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P6_End",
    id: "flowchart-P6_End-8",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 102.0625,
    y: -22.5,
    x: -51.03125,
    ry: 3,
    "data-id": "P6_End",
    rx: 3,
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.03125, -10.5)",
    style: {},
    className: "label"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 70.0625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span17 || (_span17 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "To Phase 7")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "130%",
    height: "130%",
    id: "drop-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 4,
    dx: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "150%",
    height: "150%",
    id: "drop-shadow-small"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 2,
    dx: 2
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    y2: "0%",
    x2: "100%",
    y1: "0%",
    x1: "0%",
    gradientUnits: "objectBoundingBox",
    id: "export-svg-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0042eb",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#eb0042",
    offset: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase5VectorSearchViz);
export default __webpack_public_path__ + "static/media/phase5_vector_search_viz.86dd5f1ee47b60fb118f433da19976e3.svg";
export { ForwardRef as ReactComponent };